import { useCallback } from "react";

export const useThemeToBody = (): {
  themeToBody: () => void;
  getThemeUrlIcon: (i?: string) => string;
} => {
  // TODO: This chould be change
  const userSettings = {
    darkMode: false
  };
  const themeToBody = useCallback(() => {
    if (userSettings?.darkMode) {
      document.body.setAttribute("data-mode", "dark");
    } else {
      document.body.removeAttribute("data-mode");
    }
  }, [userSettings?.darkMode]);

  const getThemeUrlIcon = (i?: string): string => {
    return i
      ? userSettings?.darkMode
        ? i.split(".svg")[0] + "_dark.svg"
        : i
      : "";
  };

  return { themeToBody, getThemeUrlIcon };
};
